import React, {useEffect} from 'react';
import { Outlet } from 'react-router-dom';
import logo from '../images/logo-full.svg';

function AuthLayout() {
	useEffect(() => {
 
	  if (!document.body.classList.contains('minimal-layout')) {
		document.body.classList.add('minimal-layout');
	  }
	}, []);

	return (
		<div className="auth-layout">
			<div className="logo">
				<img src={logo} alt="Logo" />
			</div>
			<div className="container">
				<div className="auth-info-container">
					<Outlet />
				</div>
			</div>
		</div>
	);
}

export default AuthLayout;